"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var alt_1 = require("../../alt");
var api_request_1 = require("../../api_request");
var url_helpers_1 = require("../../shared/url_helpers");
var CategoriesActions = /** @class */ (function () {
    function CategoriesActions() {
    }
    CategoriesActions.prototype.loaded = function (response) {
        return response;
    };
    CategoriesActions.prototype.fetch = function () {
        var _this = this;
        return function () {
            api_request_1.default.V3.get(url_helpers_1.default.categoriesFlatPath()).then(function (response) {
                _this.loaded(response);
            }).fail(function (err) {
                throw (err);
            });
        };
    };
    return CategoriesActions;
}());
exports.default = alt_1.default.createActions(CategoriesActions);
//# sourceMappingURL=categories_actions.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/actions/categories_actions.js
// module id = i2/0
// module chunks = 20 21